<script lang="ts">
  import Page404 from '$lib/components/Page404.svelte';

</script>
<main class="stripe-inside">
  <Page404></Page404>
</main>
